import { ChallengeVisibility } from '../core-api';

export const defaultChallengeVisibility: ChallengeVisibility = {
  comments: {
    enabled: true,
    attachmentsEnabled: true
  },
  ideaSubmissionEnabled: true,
  ideasVisible: true,
  jointSubmissionEnabled: false,
  showClosedEnabled: false,
  voteOnCommentsEnabled: true,
  voteOnIdeasEnabled: true,
  privateSubmissionEnabled: false,
  ideaEditLock: {
    enabled: false,
    graceMinutes: 120
  },
  phaseAutoAdvancement: true,
  phaseResetComments: false,
  phaseResetVotes: false,
  shareFacebookEnabled: false,
  shareTwitterEnabled: false,
  shareLinkedInEnabled: false,
  copyUrlEnabled: false
};
